import { render, staticRenderFns } from "./tabClient.vue?vue&type=template&id=422cc1f6&scoped=true&"
import script from "./tabClient.vue?vue&type=script&lang=js&"
export * from "./tabClient.vue?vue&type=script&lang=js&"
import style0 from "./tabClient.vue?vue&type=style&index=0&id=422cc1f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422cc1f6",
  null
  
)

export default component.exports